(function () {
  'use strict';

  function garage() {
    return window.COVER11_GARAGE ? window.COVER11_GARAGE() : [];
  }

  function saveGarage(list) {
    try { localStorage.setItem('solum-garage', JSON.stringify(list.slice(0, 4))); } catch (e) {}
    window.dispatchEvent(new CustomEvent('solum-garage-set', { detail: list }));
    renderGarageUI();
  }

  function activeCar() { return garage()[0] || null; }

  function carLabel(car) {
    if (!car) return 'Add your vehicle';
    var raw = (car.name || car.model || car.id || 'Vehicle').toString();
    var nm = raw.replace(/^\S+\s+/, '');
    var out = ((car.year ? car.year + ' ' : '') + nm).trim();
    if (car.cfg && car.cfg !== 'Standard') out += ' ' + car.cfg;
    return out;
  }

  function vehicleHref(car) {
    if (!car) return '/pages/all-vehicles';
    if (car.href) return car.href;
    if (car.gen) return '/pages/vehicle?g=' + encodeURIComponent(car.gen);
    return '/pages/vehicle?v=' + encodeURIComponent((car.name || '').replace(/\s+/g, '~'));
  }

  function renderGarageUI() {
    var car = activeCar();
    document.querySelectorAll('[data-c11-garage-label]').forEach(function (el) {
      el.textContent = car ? carLabel(car) : 'Add your vehicle';
    });
    document.querySelectorAll('[data-c11-garage-dot]').forEach(function (el) {
      el.classList.toggle('c11-dot--on', !!car);
      el.classList.toggle('c11-dot--warn', !car);
    });
    document.querySelectorAll('[data-c11-garage-cta]').forEach(function (el) {
      el.textContent = car ? 'SHOP →' : 'ADD →';
    });
    document.querySelectorAll('[data-c11-garage-btn]').forEach(function (btn) {
      btn.classList.toggle('is-filled', !!car);
    });
    document.querySelectorAll('[data-c11-garage-strip]').forEach(function (strip) {
      if (car) {
        strip.setAttribute('href', vehicleHref(car));
        strip.removeAttribute('data-c11-panel-toggle');
      } else {
        strip.setAttribute('href', '#');
        strip.setAttribute('data-c11-panel-toggle', 'finder');
      }
    });
    var shop = document.querySelector('[data-c11-garage-shop]');
    if (shop) {
      if (car) {
        shop.hidden = false;
        shop.textContent = 'Shop for ' + carLabel(car) + ' →';
        shop.href = vehicleHref(car);
      } else {
        shop.hidden = true;
      }
    }
    document.querySelectorAll('[data-c11-mega-fit]').forEach(function (el) {
      if (car) {
        el.textContent = '✓ Your ' + carLabel(car);
        el.href = vehicleHref(car);
        el.classList.add('c11-mega__link--hot');
      } else {
        el.textContent = 'Add your vehicle →';
        el.href = '/pages/all-vehicles';
      }
    });
    var list = document.querySelector('[data-c11-garage-list]');
    if (list) {
      list.innerHTML = '';
      garage().forEach(function (item, i) {
        var row = document.createElement('div');
        row.className = 'c11-garage-row' + (i === 0 ? ' is-active' : '');
        row.innerHTML = '<button type="button" class="c11-garage-pick"><span class="c11-dot' + (i === 0 ? ' c11-dot--on' : '') + '"></span><span>' + carLabel(item) + '</span></button><button type="button" class="c11-garage-remove" aria-label="Remove">✕</button>';
        row.querySelector('.c11-garage-pick').addEventListener('click', function () {
          var next = [item].concat(garage().filter(function (x) { return x !== item && x.id !== item.id; }));
          saveGarage(next);
          closePanels();
        });
        row.querySelector('.c11-garage-remove').addEventListener('click', function () {
          saveGarage(garage().filter(function (x) { return x !== item && x.id !== item.id; }));
        });
        list.appendChild(row);
      });
      /* SiteHeader2: empty garage opens finder — no empty-state copy in panel */
    }
  }

  function yearsFromDb(db) {
    var years = [];
    if (!db || !db.CAT || !db.CAT.length) return years;
    var max = Math.max.apply(null, db.CAT.map(function (c) { return c[3]; }));
    var min = Math.min.apply(null, db.CAT.map(function (c) { return c[2]; }));
    for (var y = max; y >= min; y--) years.push(y);
    return years;
  }

  function fillSelect(sel, values, placeholder) {
    if (!sel) return;
    var current = sel.value;
    sel.innerHTML = '';
    var opt0 = document.createElement('option');
    opt0.value = '';
    opt0.textContent = placeholder;
    sel.appendChild(opt0);
    values.forEach(function (v) {
      var o = document.createElement('option');
      o.value = v;
      o.textContent = v;
      sel.appendChild(o);
    });
    if (values.indexOf(current) >= 0) sel.value = current;
  }

  function pickVehicle(g, year) {
    var entry = {
      id: g.id || g.short,
      gen: g.id,
      name: g.name,
      year: year || null,
      model: g.model || g.name,
      cfg: (g.cfgs && g.cfgs.length === 1) ? g.cfgs[0] : null
    };
    var list = garage().filter(function (x) { return x.gen !== entry.gen && x.id !== entry.id; });
    saveGarage([entry].concat(list));
    closePanels();
    window.location.href = g.href || '/pages/all-vehicles';
  }

  function bindFinder(root) {
    if (!root || root.dataset.bound) return;
    root.dataset.bound = '1';
    var yearSel = root.querySelector('[data-c11-year]');
    var makeSel = root.querySelector('[data-c11-make]');
    var modelSel = root.querySelector('[data-c11-model]');
    var goBtn = root.querySelector('[data-c11-go]');

    function refresh() {
      var db = window.SOLUM_DB;
      if (!db) return;
      if (!db.CAT.length) {
        [yearSel, makeSel, modelSel].forEach(function (el) { if (el) el.disabled = true; });
        if (goBtn) { goBtn.disabled = true; goBtn.textContent = window.C11_CATALOG_UNAVAILABLE; }
        return;
      }
      fillSelect(yearSel, yearsFromDb(db).map(String), 'Year');
      var fy = +(yearSel && yearSel.value) || null;
      var inY = fy ? db.CAT.filter(function (c) { return fy >= c[2] && fy <= c[3]; }) : db.CAT;
      fillSelect(makeSel, Array.from(new Set(inY.map(function (c) { return c[0]; }))).sort(), 'Make');
      var fmk = makeSel && makeSel.value;
      var mods = fmk ? Array.from(new Set(inY.filter(function (c) { return c[0] === fmk; }).map(function (c) { return c[1]; }))).sort() : [];
      fillSelect(modelSel, mods, 'Model');
      var fmd = modelSel && modelSel.value;
      var fc = fy && fmk && fmd ? inY.find(function (c) { return c[0] === fmk && c[1] === fmd; }) : null;
      var fg = fc && db.gen ? db.gen(fc) : null;
      if (!goBtn) return;
      if (fg) {
        goBtn.disabled = false;
        goBtn.className = 'c11-btn c11-btn--signal c11-finder__go';
        goBtn.textContent = 'Show parts for my ' + fy + ' ' + fg.model + ' →';
        goBtn.onclick = function () { pickVehicle(fg, fy); };
      } else {
        goBtn.disabled = true;
        goBtn.className = 'c11-btn c11-btn--muted c11-finder__go';
        goBtn.textContent = 'Pick year, make and model';
        goBtn.onclick = null;
      }
    }

    [yearSel, makeSel, modelSel].forEach(function (el) {
      if (!el) return;
      el.addEventListener('change', function () {
        if (el === yearSel && makeSel) makeSel.value = '';
        if ((el === yearSel || el === makeSel) && modelSel) modelSel.value = '';
        refresh();
      });
    });

    waitDb(refresh);
  }

  function waitDb(cb) {
    if (window.SOLUM_DB) { cb(); return; }
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (window.SOLUM_DB || tries > 50) { clearInterval(t); cb(); }
    }, 100);
  }

  function renderPopular() {
    var nodes = document.querySelectorAll('[data-c11-popular], [data-c11-panel-popular]');
    waitDb(function () {
      if (!window.SOLUM_DB || !window.SOLUM_DB.popular) return;
      nodes.forEach(function (wrap) {
        wrap.innerHTML = '';
        window.SOLUM_DB.popular().slice(0, 8).forEach(function (x) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = wrap.hasAttribute('data-c11-popular') ? 'c11-chip' : 'c11-panel__item';
          if (wrap.hasAttribute('data-c11-popular')) {
            btn.textContent = x.name;
          } else {
            btn.innerHTML = '<span>' + escapeHTML(x.name) + '</span><span>' + escapeHTML(x.years || '') + '</span>';
          }
          btn.addEventListener('click', function () { pickVehicle(x, null); });
          wrap.appendChild(btn);
        });
        if (wrap.hasAttribute('data-c11-popular')) {
          var all = document.createElement('a');
          all.href = '/pages/all-vehicles';
          all.className = 'c11-chip c11-chip--accent';
          all.textContent = 'All vehicles →';
          wrap.appendChild(all);
        }
      });
    });
  }

  function bindVehicleSearch() {
    var input = document.querySelector('[data-c11-veh-q]');
    var hits = document.querySelector('[data-c11-veh-hits]');
    var noHit = document.querySelector('[data-c11-veh-nohit]');
    if (!input || !hits) return;
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      hits.innerHTML = '';
      if (noHit) noHit.hidden = true;
      if (q.length < 2 || !window.SOLUM_DB) return;
      var tok = q.split(/\s+/).filter(Boolean);
      window.SOLUM_DB.CAT.filter(function (c) {
        return tok.every(function (t) { return (c[0] + ' ' + c[1]).toLowerCase().indexOf(t) >= 0; });
      }).slice(0, 6).forEach(function (c) {
        var g = window.SOLUM_DB.gen(c);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'c11-panel__item';
        var metaColor = g.status === 'test' ? '#F2C200' : '#8A8C8E';
        btn.innerHTML = '<span>' + escapeHTML(g.name) + '</span><span style="color:' + metaColor + '">' + escapeHTML(g.years) + (g.status === 'test' ? ' · IN TESTING' : '') + '</span>';
        btn.addEventListener('click', function () { pickVehicle(g, null); });
        hits.appendChild(btn);
      });
      if (!hits.children.length && noHit) noHit.hidden = false;
    });
  }

  function closePanels() {
    document.querySelectorAll('[data-c11-panel]').forEach(function (p) { p.hidden = true; });
    document.querySelectorAll('[data-c11-panel-toggle]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
      b.classList.remove('is-open');
    });
    document.querySelectorAll('[data-c11-garage-btn]').forEach(function (b) { b.classList.remove('is-open'); });
    closeAllC11Selects();
    var drawer = document.querySelector('[data-c11-drawer]');
    var cartOpen = document.querySelector('[data-c11-cart-drawer].is-open');
    if (!(drawer && drawer.classList.contains('is-open')) && !cartOpen) {
      document.body.style.overflow = '';
      liftHeader(false);
    }
  }

  function openPanel(name) {
    closePanels();
    var panel = document.querySelector('[data-c11-panel="' + name + '"]');
    if (!panel) return;
    panel.hidden = false;
    document.querySelectorAll('[data-c11-panel-toggle="' + name + '"]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'true');
      b.classList.add('is-open');
    });
    if (name === 'garage') {
      document.querySelectorAll('[data-c11-garage-btn]').forEach(function (b) { b.classList.add('is-open'); });
    }
    if (name === 'finder') {
      var noHit = document.querySelector('[data-c11-veh-nohit]');
      if (noHit) noHit.hidden = true;
      var vehHits = document.querySelector('[data-c11-veh-hits]');
      if (vehHits) vehHits.innerHTML = '';
    }
    liftHeader(true);
    if (name === 'search') {
      document.body.style.overflow = 'hidden';
      var input = document.querySelector('[data-c11-search-input]');
      var results = document.querySelector('[data-c11-search-results]');
      if (input) {
        input.value = '';
        setTimeout(function () { input.focus(); }, 10);
      }
      if (results) results.innerHTML = '';
    }
    var drawer = document.querySelector('[data-c11-drawer]');
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }
  }

  function anyNavPanelOpen() {
    return !!document.querySelector(
      '[data-c11-panel="finder"]:not([hidden]), [data-c11-panel="floor"]:not([hidden]), [data-c11-panel="cover"]:not([hidden]), [data-c11-panel="pet"]:not([hidden]), [data-c11-panel="kits"]:not([hidden]), [data-c11-panel="garage"]:not([hidden])'
    );
  }

  function bindPanels() {
    document.addEventListener('click', function (e) {
      var strip = e.target.closest('[data-c11-garage-strip]');
      if (strip && activeCar()) {
        // let the link navigate to the vehicle page
        return;
      }
      var btn = e.target.closest('[data-c11-panel-toggle]');
      if (!btn) return;
      e.preventDefault();
      var name = btn.getAttribute('data-c11-panel-toggle');
      if (!name) return;
      var panel = document.querySelector('[data-c11-panel="' + name + '"]');
      if (panel && !panel.hidden && (btn.getAttribute('aria-expanded') === 'true' || btn.classList.contains('is-open'))) {
        closePanels();
      } else if (name === 'garage' && !garage().length) {
        openPanel('finder');
      } else {
        openPanel(name);
      }
    });
    /* SiteHeader v1: if a nav panel is open, hover switches to that menu */
    document.querySelectorAll('[data-c11-nav-hover]').forEach(function (btn) {
      btn.addEventListener('mouseenter', function () {
        if (!anyNavPanelOpen()) return;
        var name = btn.getAttribute('data-c11-nav-hover');
        if (name) openPanel(name);
      });
    });
    document.querySelectorAll('[data-c11-open-garage]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openPanel(garage().length ? 'garage' : 'finder');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
    document.querySelectorAll('[data-c11-panel-close]').forEach(function (btn) {
      btn.addEventListener('click', closePanels);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closePanels();
      var drawer = document.querySelector('[data-c11-drawer]');
      if (drawer) {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
      }
      document.body.style.overflow = '';
      liftHeader(false);
    });
    document.addEventListener('mousedown', function (e) {
      if (!e.target.closest('[data-hd-panel]') && !e.target.closest('[data-c11-panel-toggle]') && !e.target.closest('[data-c11-garage-strip]') && !e.target.closest('[data-c11-open-garage]') && !e.target.closest('[data-c11-drawer]') && !e.target.closest('[data-c11-menu-open]')) {
        if (anyNavPanelOpen()) closePanels();
      }
    });
  }

  function bindDrawerAccordions() {
    document.querySelectorAll('[data-c11-acc-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-c11-acc-toggle');
        var body = document.querySelector('[data-c11-acc="' + id + '"]');
        if (!body) return;
        var open = body.hidden;
        document.querySelectorAll('[data-c11-acc]').forEach(function (b) { b.hidden = true; });
        document.querySelectorAll('[data-c11-acc-toggle]').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          var s = b.querySelector('[data-c11-acc-sign]');
          if (s) s.textContent = '+';
        });
        if (open) {
          body.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
          var sign = btn.querySelector('[data-c11-acc-sign]');
          if (sign) sign.textContent = '−';
        }
      });
    });
  }

  function bindHeaderSearch() {
    const input=document.querySelector('[data-c11-search-input]'),results=document.querySelector('[data-c11-search-results]'),node=document.getElementById('Cover11GlobalSearchConfig');
    if(!input||!results||!node||input.dataset.globalSearchReady)return;
    let config;try{config=JSON.parse(node.textContent);}catch(_){return;}
    input.dataset.globalSearchReady='true';input.maxLength=100;results.id='Cover11GlobalSearchResults';input.setAttribute('aria-controls',results.id);
    const form=input.closest('form'),normal=value=>String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim(),text=key=>config.messages[key]||key;
    let revision=0,timer,controller,vehicleHits=[];
    const contextual=url=>{const target=new URL(url,location.origin);if(target.origin!==location.origin)throw Error('origin');const current=new URL(location.href);for(const key of['preview_theme_id','pb'])if(current.searchParams.has(key))target.searchParams.set(key,current.searchParams.get(key));return target;};
    const vehicleUrl=(row,value)=>{const url=contextual(config.modelUrl);url.searchParams.set('make',String(row.makeId||row.nhtsaMakeId));url.searchParams.set('model',String(row.modelId||row.nhtsaModelId||row.id));const years=value.match(/\b\d{4}\b/g)||[];if(years.length===1&&window.COVER11_SHOP.hasYear(row,years[0]))url.searchParams.set('year',years[0]);return url.href;};
    const directoryUrl=value=>{const url=contextual(config.directoryUrl);url.searchParams.set('q',value);const years=value.match(/\b\d{4}\b/g)||[];if(years.length===1)url.searchParams.set('year',years[0]);return url.href;};
    const productSearchUrl=value=>{const url=contextual(form.action);url.search='';for(const[key,val]of new FormData(form))url.searchParams.append(key,String(val));url.searchParams.set('q',value);const current=new URL(location.href);for(const key of['preview_theme_id','pb'])if(current.searchParams.has(key))url.searchParams.set(key,current.searchParams.get(key));return url.href;};
    function matchingVehicles(rows,value){const tokens=normal(value).split(' ').filter(Boolean);if(!tokens.length)return[];return rows.filter(row=>typeof row.id==='string'&&tokens.every(token=>/^\d{4}$/.test(token)?window.COVER11_SHOP.hasYear(row,token):normal(row.make+' '+row.model).replace(/ /g,'').includes(token))).sort((a,b)=>(a.make+' '+a.model).localeCompare(b.make+' '+b.model));}
    function link(label,kind,url){const a=document.createElement('a');a.className='c11-search__hit';a.href=url;const name=document.createElement('span'),type=document.createElement('span');name.textContent=label;type.textContent=kind;a.append(name,type);return a;}
    function note(message,retry){const p=document.createElement('p');p.className='c11-global-search-status';p.setAttribute('role','status');p.textContent=message;results.append(p);if(retry){const b=document.createElement('button');b.type='button';b.className='c11-search__hit';b.textContent=text('retry');b.addEventListener('click',()=>run(input.value.trim(),++revision));results.append(b);}}
    async function findProducts(value,signal){const terms=value.normalize('NFKC').match(/[\p{L}\p{N}]+/gu)?.slice(0,20)||[];if(!terms.length)return[];const scope='(product_type:"Floor liners" OR product_type:"Cargo liners") AND ('+terms.map(term=>term+'*').join(' AND ')+')';const response=await fetch('/api/2026-10/graphql.json',{method:'POST',credentials:'same-origin',signal,headers:{'Content-Type':'application/json'},body:JSON.stringify({query:config.productQuery,variables:{query:scope,country:config.country}})});if(!response.ok)throw Error('products');const body=await response.json(),rows=body.data?.products?.nodes;if(body.errors?.length||!Array.isArray(rows))throw Error('products');if(rows.some(row=>!['Floor liners','Cargo liners'].includes(row.productType)||!/^[a-z0-9][a-z0-9-]*$/.test(row.handle)||typeof row.title!=='string'))throw Error('scope');return rows.map(row=>({title:row.title,url:config.root+'products/'+row.handle}));}
    async function run(value,version){
      controller?.abort();controller=new AbortController();const request=controller;const timeout=setTimeout(()=>request.abort(),12000);results.replaceChildren();results.setAttribute('aria-busy','true');note(text('loading'));
      try{
        const[vehicles,products]=await Promise.allSettled([window.COVER11_SHOP.listVehicles(),findProducts(value,request.signal)]);
        if(version!==revision||input.value.trim()!==value)return;
        results.replaceChildren();vehicleHits=vehicles.status==='fulfilled'?matchingVehicles(vehicles.value,value):[];
        vehicleHits.slice(0,6).forEach(row=>results.append(link(window.COVER11_SHOP.vehicleName(row),text('vehicle'),vehicleUrl(row,value))));
        let productHits=products.status==='fulfilled'?products.value:config.products.filter(row=>normal(value).split(' ').filter(Boolean).every(token=>normal(row.title+' '+row.aliases).replace(/ /g,'').includes(token)));
        productHits.slice(0,6).forEach(row=>results.append(link(row.title,text('product'),contextual(row.url).href)));
        if(vehicleHits.length>6)results.append(link(text('all_vehicles')+' ('+vehicleHits.length+')',text('vehicle'),directoryUrl(value)));
        if(productHits.length||products.status==='rejected')results.append(link(text('all_products'),text('product'),productSearchUrl(value)));
        if(vehicles.status==='rejected'||products.status==='rejected')note(text('partial_error'),true);
        else if(!vehicleHits.length&&!productHits.length)note(text('empty'));
      }finally{clearTimeout(timeout);if(version===revision)results.removeAttribute('aria-busy');}
    }
    input.addEventListener('input',()=>{clearTimeout(timer);controller?.abort();const version=++revision,value=input.value.trim().slice(0,100);vehicleHits=[];results.replaceChildren();results.removeAttribute('aria-busy');if(value.length<2)return;timer=setTimeout(()=>run(value,version),180);});
    form.addEventListener('submit',async event=>{const value=input.value.trim().slice(0,100);if(value.length<2)return;event.preventDefault();clearTimeout(timer);try{const rows=await window.COVER11_SHOP.listVehicles();if(input.value.trim()!==value)return;const hits=matchingVehicles(rows,value);location.assign(hits.length?directoryUrl(value):productSearchUrl(value));}catch(_){location.assign(productSearchUrl(value));}});
    input.addEventListener('keydown',event=>{if(event.key==='ArrowDown'){const first=results.querySelector('a,button');if(first){event.preventDefault();first.focus();}}});
    results.addEventListener('keydown',event=>{const items=[...results.querySelectorAll('a,button')],index=items.indexOf(document.activeElement);if(event.key==='ArrowDown'){event.preventDefault();items[(index+1)%items.length]?.focus();}if(event.key==='ArrowUp'){event.preventDefault();if(index<=0)input.focus();else items[index-1]?.focus();}if(event.key==='Escape'){document.querySelector('[data-c11-panel="search"] [data-c11-panel-close]')?.click();document.querySelector('[data-c11-panel-toggle="search"]')?.focus();}});
  }

  function bindFaq() {
    document.querySelectorAll('[data-c11-faq-tabs]').forEach(function (tabs) {
      var buttons = tabs.querySelectorAll('[data-c11-faq-tab]');
      var panels = document.querySelectorAll('[data-c11-faq-panel]');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-c11-faq-tab');
          buttons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          panels.forEach(function (p) { p.hidden = p.getAttribute('data-c11-faq-panel') !== id; });
        });
      });
    });
    document.querySelectorAll('[data-c11-faq] details').forEach(function (d) {
      d.addEventListener('toggle', function () {
        var mark = d.querySelector('[data-c11-faq-mark]');
        if (mark) mark.textContent = d.open ? '−' : '+';
      });
    });
  }

  function liftHeader(on) {
    var header = document.querySelector('[data-c11-header]');
    if (header) header.classList.toggle('is-lifted', !!on);
  }

  function bindDrawer() {
    var drawer = document.querySelector('[data-c11-drawer]');
    var openBtn = document.querySelector('[data-c11-menu-open]');
    var closeBtns = document.querySelectorAll('[data-c11-menu-close]');
    var backdrop = document.querySelector('[data-c11-drawer-backdrop]');
    function open() {
      if (!drawer) return;
      closePanels();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      liftHeader(true);
    }
    function close() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (!document.querySelector('[data-c11-panel="search"]:not([hidden])') &&
          !document.querySelector('[data-c11-cart-drawer].is-open')) {
        document.body.style.overflow = '';
        liftHeader(false);
      }
    }
    if (openBtn) openBtn.addEventListener('click', open);
    closeBtns.forEach(function (btn) { btn.addEventListener('click', close); });
    if (backdrop) backdrop.addEventListener('click', close);
    document.querySelectorAll('[data-c11-menu-close][href]').forEach(function () {});
    drawer && drawer.querySelectorAll('a[data-c11-menu-close]').forEach(function (a) {
      a.addEventListener('click', close);
    });
  }

  function escapeHTML(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) { return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]; });
  }
  function moneyFromCart(cents) {
    return new Intl.NumberFormat(window.C11_LOCALE || 'en', { style: 'currency', currency: window.C11_CURRENCY || 'EUR' }).format((+cents || 0) / 100);
  }
  window.C11_money = moneyFromCart;

  function cartEta() {
    var et = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
    var wk = et.getDay() > 0 && et.getDay() < 6;
    var cut = new Date(et); cut.setHours(14, 0, 0, 0);
    var ship = new Date(et);
    var left = null;
    if (wk && et < cut) left = cut - et;
    else {
      do { ship.setDate(ship.getDate() + 1); } while (ship.getDay() === 0 || ship.getDay() === 6);
    }
    var arr = new Date(ship); var n = 0;
    while (n < 4) { arr.setDate(arr.getDate() + 1); if (arr.getDay() > 0 && arr.getDay() < 6) n++; }
    var date = arr.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }).toUpperCase().replace(',', '');
    return {
      date: 'ARRIVES ' + date,
      cut: left
        ? ('ORDER IN ' + Math.floor(left / 3600000) + 'H ' + Math.floor((left % 3600000) / 60000) + 'M · SHIPS TODAY')
        : 'SHIPS NEXT BUSINESS DAY'
    };
  }

  function bindCartDrawer() {
    var root = document.querySelector('[data-c11-cart-drawer]');
    if (!root) return;
    var linesEl = root.querySelector('[data-c11-cart-lines]');
    var emptyEl = root.querySelector('[data-c11-cart-empty]');
    var footEl = root.querySelector('[data-c11-cart-foot]');
    var titleEl = root.querySelector('[data-c11-cart-title]');
    var countLabel = root.querySelector('[data-c11-cart-count-label]');
    var subEl = root.querySelector('[data-c11-cart-subtotal]');
    var installmentsEl = root.querySelector('[data-c11-cart-installments]');
    var bandEl = root.querySelector('[data-c11-cart-band]');
    var bandText = root.querySelector('[data-c11-cart-band-text]');
    var bandBar = root.querySelector('[data-c11-cart-band-bar]');
    var etaEl = root.querySelector('[data-c11-cart-eta]');
    var etaDate = root.querySelector('[data-c11-cart-eta-date]');
    var etaCut = root.querySelector('[data-c11-cart-eta-cut]');
    var errorBox = root.querySelector('[data-c11-cart-error]');
    var errorMessage = root.querySelector('[data-c11-cart-error-message]');
    var cartUrl = window.C11_CART_URL || '/cart';
    function showError(message) { if (errorBox) errorBox.hidden = false; if (errorMessage) errorMessage.textContent = message; }
    function clearError() { if (errorBox) errorBox.hidden = true; }
    async function cartRequest(url, options) {
      var response = await fetch(url, options);
      var body = await response.json();
      if (!response.ok) throw new Error(typeof body.description === 'string' ? body.description : window.C11_CART_ERROR);
      if (!Array.isArray(body.items)) throw new Error(window.C11_CART_READ_ERROR);
      return body;
    }
    var retry = root.querySelector('[data-c11-cart-retry]');
    if (retry) retry.addEventListener('click', refresh);

    function setOpen(open) {
      root.hidden = !open;
      root.setAttribute('aria-hidden', open ? 'false' : 'true');
      root.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) closePanels();
    }

    function paint(cart) {
      clearError();
      var items = (cart && cart.items) || [];
      var count = cart ? cart.item_count : 0;
      document.querySelectorAll('[data-c11-cart-count]').forEach(function (el) {
        el.textContent = String(count);
      });
      if (titleEl) titleEl.textContent = count ? 'Cart' : 'Cart';
      if (countLabel) countLabel.textContent = count + ' ITEM(S)';
      if (!items.length) {
        if (emptyEl) emptyEl.hidden = false;
        if (linesEl) { linesEl.hidden = true; linesEl.innerHTML = ''; }
        if (footEl) footEl.hidden = true;
        if (bandEl) bandEl.hidden = true;
        if (etaEl) etaEl.hidden = true;
        return;
      }
      if (emptyEl) emptyEl.hidden = true;
      if (bandEl) {
        bandEl.hidden = false;
        var car = activeCar();
        if (bandText) bandText.textContent = car
          ? ('SELECTED VEHICLE · ' + carLabel(car).toUpperCase())
          : 'CHECK COMPATIBILITY ON THE PRODUCT PAGE';
        if (bandBar) bandBar.style.background = car ? 'var(--ok)' : 'var(--warn)';
      }
      if (linesEl) {
        linesEl.hidden = false;
        linesEl.innerHTML = items.map(function (item) {
          var img = (item.image || '').replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2');
          var props = [];
          if (item.properties) {
            Object.keys(item.properties).forEach(function (k) {
              if (k.charAt(0) !== '_' && item.properties[k]) props.push(item.properties[k]);
            });
          }
          return '<li class="c11-cartdraw__line">' +
            '<a class="c11-cartdraw__thumb c11-ph" href="' + escapeHTML(item.url) + '">' +
              (img ? '<img src="' + escapeHTML(img) + '" alt="" width="72" height="72" loading="lazy">' : '') +
            '</a>' +
            '<div class="c11-cartdraw__meta">' +
              '<a href="' + escapeHTML(item.url) + '"><b>' + escapeHTML(item.product_title) + '</b></a>' +
              (props.length ? '<span class="c11-mono">' + escapeHTML(props.join(' · ')) + '</span>' : '') +
              (item.variant_title && item.variant_title !== 'Default Title'
                ? '<span class="c11-mono">' + escapeHTML(item.variant_title) + '</span>' : '') +
              '<span class="c11-mono">QTY ' + item.quantity + '</span>' +
              '<button type="button" class="c11-cartdraw__remove" data-c11-cart-remove="' + escapeHTML(item.key) + '">' + escapeHTML(window.C11_CART_REMOVE || 'Remove') + '</button>' +
            '</div>' +
            '<strong class="c11-cartdraw__price">' + moneyFromCart(item.final_line_price) + '</strong>' +
          '</li>';
        }).join('');
        linesEl.querySelectorAll('[data-c11-cart-remove]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var key = btn.getAttribute('data-c11-cart-remove');
            btn.disabled = true;
            cartRequest(cartUrl + '/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: key, quantity: 0 })
            }).then(paint).catch(function (error) { showError(error.message || window.C11_CART_ERROR); }).finally(function () { btn.disabled = false; });
          });
        });
      }
      if (subEl) subEl.textContent = moneyFromCart(cart.total_price);
      if (installmentsEl) {
        installmentsEl.hidden = true;
      }
      var eta = cartEta();
      if (etaEl) etaEl.hidden = true;
      if (etaDate) etaDate.textContent = eta.date;
      if (etaCut) etaCut.textContent = eta.cut;
      if (footEl) footEl.hidden = false;
    }

    function refresh() {
      return cartRequest(cartUrl + '.js', { headers: { Accept: 'application/json' } })
        .then(paint)
        .catch(function () { showError(window.C11_CART_READ_ERROR); });
    }

    function open() {
      setOpen(true);
      refresh();
    }

    document.querySelectorAll('[data-c11-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var menu = document.querySelector('[data-c11-drawer]');
        if (menu) menu.classList.remove('is-open');
        open();
      });
    });
    root.querySelectorAll('[data-c11-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        setOpen(false);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) setOpen(false);
    });
    window.addEventListener('c11-cart-open', open);
    window.addEventListener('c11-cart-refresh', refresh);
    window.addEventListener('cart:refresh', refresh);
  }

  function bindContactTopics() {
    document.querySelectorAll('[data-c11-topic]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('[data-c11-topic]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var input = document.querySelector('[data-c11-topic-input]');
        if (input) input.value = btn.getAttribute('data-c11-topic');
      });
    });
  }

  function bindHomeHero() {
    var root = document.querySelector('[data-c11-home-hero]');
    if (!root) return;
    var carBox = root.querySelector('[data-c11-hero-car]');
    var finder = root.querySelector('[data-c11-hero-finder]');
    var nameEl = root.querySelector('[data-c11-hero-car-name]');
    var shop = root.querySelector('[data-c11-hero-car-shop]');
    var change = root.querySelector('[data-c11-hero-car-change]');
    var changing = false;

    function sync() {
      var car = activeCar();
      var show = !!car && !changing;
      if (carBox) carBox.hidden = !show;
      if (finder) finder.hidden = show;
      if (show && car) {
        var label = ((car.year ? car.year + ' ' : '') + (car.name || car.model || 'Vehicle') + (car.cfg && car.cfg !== 'Standard' ? ' ' + car.cfg : '')).trim();
        if (nameEl) nameEl.textContent = label;
        if (shop) {
          shop.href = vehicleHref(car);
          shop.textContent = 'Shop for my ' + (car.model || 'vehicle') + ' →';
        }
      }
    }

    if (change) {
      change.addEventListener('click', function () {
        changing = true;
        sync();
      });
    }
    window.addEventListener('solum-garage-set', function () {
      changing = false;
      sync();
    });
    sync();
  }

  function bindReveal() {
    var nodes = document.querySelectorAll('.c11-reveal, [data-c11-reveal]');
    if (!nodes.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    nodes.forEach(function (n) { io.observe(n); });
  }

  function closeAllC11Selects(except) {
    document.querySelectorAll('.c11-select.is-open').forEach(function (wrap) {
      if (except && wrap === except) return;
      wrap.classList.remove('is-open');
      var btn = wrap.querySelector('.c11-select__btn');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function enhanceSelect(sel) {
    if (!sel || sel.tagName !== 'SELECT' || sel.multiple || sel.dataset.c11SelectBound === '1') return;
    if (sel.hasAttribute('data-collection-vehicle')) return;
    if (sel.closest('.c11-production-page, .c11r-pdp')) return;
    if (sel.closest('.shopify-payment-button, .shopify-cleanslate, [data-shopify-buttoncontainer]')) return;
    sel.dataset.c11SelectBound = '1';

    var wrap = document.createElement('div');
    wrap.className = 'c11-select';
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(sel);
    sel.classList.add('c11-select__native');
    if (!sel.classList.contains('c11-field')) sel.classList.add('c11-field');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'c11-select__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    if (sel.id) btn.setAttribute('aria-labelledby', sel.id);
    else if (sel.getAttribute('aria-label')) btn.setAttribute('aria-label', sel.getAttribute('aria-label'));
    btn.innerHTML = '<span class="c11-select__btn-label"></span><span class="c11-select__chev" aria-hidden="true"></span>';
    wrap.appendChild(btn);

    var menu = document.createElement('div');
    menu.className = 'c11-select__menu';
    menu.setAttribute('role', 'listbox');
    wrap.appendChild(menu);

    var labelEl = btn.querySelector('.c11-select__btn-label');

    function selectedOption() {
      return sel.options[sel.selectedIndex] || null;
    }

    function syncBtn() {
      var opt = selectedOption();
      var text = opt ? opt.textContent : (sel.getAttribute('aria-label') || 'Select');
      var isPh = !opt || !opt.value;
      labelEl.textContent = text;
      labelEl.classList.toggle('is-placeholder', !!isPh);
      wrap.classList.toggle('is-disabled', !!sel.disabled);
      btn.disabled = !!sel.disabled;
    }

    function rebuildMenu() {
      menu.innerHTML = '';
      Array.prototype.forEach.call(sel.options, function (opt, i) {
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'c11-select__opt';
        item.setAttribute('role', 'option');
        item.textContent = opt.textContent;
        if (opt.disabled) {
          item.disabled = true;
          item.classList.add('is-disabled');
        }
        if (opt.selected) item.classList.add('is-selected');
        item.addEventListener('click', function (e) {
          e.preventDefault();
          if (opt.disabled) return;
          sel.selectedIndex = i;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          syncBtn();
          closeAllC11Selects();
        });
        item.addEventListener('mouseenter', function () {
          menu.querySelectorAll('.c11-select__opt.is-active').forEach(function (n) {
            n.classList.remove('is-active');
          });
          item.classList.add('is-active');
        });
        menu.appendChild(item);
      });
      syncBtn();
    }

    function openMenu() {
      if (sel.disabled) return;
      closeAllC11Selects(wrap);
      rebuildMenu();
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      var selected = menu.querySelector('.c11-select__opt.is-selected');
      if (selected) selected.scrollIntoView({ block: 'nearest' });
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (wrap.classList.contains('is-open')) closeAllC11Selects();
      else openMenu();
    });

    sel.addEventListener('change', syncBtn);

    var mo = new MutationObserver(function () {
      rebuildMenu();
      if (wrap.classList.contains('is-open')) {
        /* keep open after dynamic option refill (Year/Make/Model) */
      }
    });
    mo.observe(sel, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });

    rebuildMenu();
  }

  function enhanceAllSelects(root) {
    (root || document).querySelectorAll('select').forEach(enhanceSelect);
  }

  document.addEventListener('DOMContentLoaded', function () {
    renderGarageUI();
    document.querySelectorAll('[data-c11-finder]').forEach(bindFinder);
    renderPopular();
    bindVehicleSearch();
    bindPanels();
    bindDrawerAccordions();
    bindHeaderSearch();
    bindFaq();
    bindDrawer();
    bindCartDrawer();
    bindContactTopics();
    bindHomeHero();
    bindReveal();

    window.addEventListener('solum-garage-set', renderGarageUI);
    document.addEventListener('mousedown', function (e) {
      if (!e.target.closest('.c11-select')) closeAllC11Selects();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllC11Selects();
    });
  });
})();

